"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLTemplatePlugin = exports.RowResultTransformerFactory = void 0;
var Mustache = __importStar(require("mustache"));
var RowResultTransformerFactory = /** @class */ (function () {
    function RowResultTransformerFactory(rowSize) {
        this.rowSize = rowSize;
    }
    RowResultTransformerFactory.prototype.build = function () {
        var rowSize = this.rowSize;
        return function (parser) {
            // return parser;
            var result = {
                rows: []
            };
            var counter = 0;
            (parser === null || parser === void 0 ? void 0 : parser.getBindings()).forEach(function (b) {
                if (counter % rowSize == 0) {
                    result.rows.push({ items: [] });
                }
                result.rows[result.rows.length - 1].items.push(b);
                counter++;
            });
            return result;
        };
    };
    return RowResultTransformerFactory;
}());
exports.RowResultTransformerFactory = RowResultTransformerFactory;
var HTMLTemplatePlugin = /** @class */ (function () {
    function HTMLTemplatePlugin(yasr) {
        this.priority = 10;
        this.yasr = yasr;
        this.config = HTMLTemplatePlugin.defaults;
    }
    HTMLTemplatePlugin.prototype.getIcon = function () {
        var svgContainer = document.createElement("div");
        svgContainer.className = "svgImg";
        // svgContainer.appendChild(svg);
        return svgContainer;
    };
    HTMLTemplatePlugin.prototype.draw = function (persistentConfig) {
        var _a, _b, _c, _d;
        console.log("HTMLTemplatePlugin Plugin drawing ! template is " + ((_a = this.config) === null || _a === void 0 ? void 0 : _a.htmlTemplate));
        // first transform the result
        var transformedResult = ((_b = this.config) === null || _b === void 0 ? void 0 : _b.resultTransformer) ? (_c = this.config) === null || _c === void 0 ? void 0 : _c.resultTransformer(this.yasr.results) : this.yasr.results;
        var mustacheResult = Mustache.render((_d = this.config) === null || _d === void 0 ? void 0 : _d.htmlTemplate, transformedResult);
        var resultContainerEl = document.createElement("div");
        resultContainerEl.setAttribute("id", "resultContainer");
        resultContainerEl.innerHTML = mustacheResult;
        console.dir(transformedResult);
        // var dummyDiv = document.createElement("div");
        // dummyDiv.innerHTML = JSON.stringify(this.yasr.results);
        // resultContainerEl.appendChild(dummyDiv);
        this.yasr.resultsEl.appendChild(resultContainerEl);
    };
    HTMLTemplatePlugin.prototype.canHandleResults = function () {
        return !!this.yasr.results && this.yasr.results.getVariables() && this.yasr.results.getVariables().length > 0;
    };
    HTMLTemplatePlugin.defaults = {
        resultTransformer: function (parser) { return parser; },
        htmlTemplate: ""
    };
    return HTMLTemplatePlugin;
}());
exports.HTMLTemplatePlugin = HTMLTemplatePlugin;
